import {useState, useEffect} from 'react';
import imageUrlBuilder from "@sanity/image-url";
import sanityClient from "../client.js";

const Screensaver = (props) => {

    const { pageData } = props;
    const [logos, setLogos] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [logoIndex, setLogoIndex] = useState(0);

      const builder = imageUrlBuilder(sanityClient);
    
      function urlFor(source) {
        return builder.image(source);
      }

      useEffect(() => {
        const logosArray = pageData.screensaver.map(image => urlFor(image));
        setLogos(logosArray);
    }, []);

    useEffect(() => {
        let timeout;
    
        const resetTimer = () => {
          setIsVisible(false);
          clearTimeout(timeout);
          timeout = setTimeout(() => setIsVisible(true), 30000);
        };
    
        window.addEventListener("mousemove", resetTimer);
        resetTimer();
    
        return () => {
          window.removeEventListener("mousemove", resetTimer);
          clearTimeout(timeout);
        };
      }, []);
    
      useEffect(() => {
        if (!isVisible || logos.length === 0) return;
    
        const interval = setInterval(() => {
          setLogoIndex((prevIndex) => (prevIndex + 1) % logos.length);
        }, 200);
    
        return () => clearInterval(interval);
      }, [isVisible, logos]);
  
    return (<>
        {isVisible && (
          <div className="screensaver__wrapper">
            {logos && logos.map((logo, index) => {
                return <div className={`screensaver__image ${index === logoIndex?'active':''}`} 
                style={{backgroundImage: `url(${logo})`}}
                />
            })}
          </div>
        )} 
    </>
 
    );
}

export default Screensaver